import { Suspense } from 'react';
import { useLocation } from 'react-router-dom';
import { RouteLoader } from './Loader';

const shellStyle = {
  position: 'relative',
  height: '100%',
  overflow: 'hidden',
};

const RoutePending = ({ children, loaderArea = 'full' }) => {
  const location = useLocation();

  return (
    <div style={shellStyle}>
      <Suspense
        key={location.pathname}
        fallback={<RouteLoader area={loaderArea} />}
      >
        {children}
      </Suspense>
    </div>
  );
};

export default RoutePending;
